import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Gates the developer dashboard (and any other authenticated developer
 * surface). Unauthenticated users are sent to /developers/auth with a
 * redirect param so they land back here after signing in.
 *
 * Any signed-in user qualifies — there is no separate "developer" role.
 */
export default function DeveloperAuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/developers/auth?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
}